import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setStudentId, getGooglePending, clearGooglePending } from "@/lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    const pending = getGooglePending();
    clearGooglePending();
    window.history.replaceState(null, "", window.location.pathname);

    api
      .post("/auth/google/session", {
        session_id: sessionId,
        student_id: pending.student_id || undefined,
        standard: pending.standard || undefined,
        board: pending.board || undefined,
      })
      .then(({ data }) => {
        setStudentId(data.id);
        toast.success(`Welcome, ${data.name}!`);
        navigate("/");
      })
      .catch((err) => {
        if (err.response?.status === 400) {
          toast.error("No account found for this Google email. Please sign up first.");
          navigate("/onboarding");
        } else {
          const detail = err.response?.data?.detail;
          toast.error(typeof detail === "string" ? detail : "Google sign-in failed. Please try again.");
          navigate("/login");
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F19] flex items-center justify-center text-white/70 text-sm" data-testid="auth-callback-page">
      Signing you in...
    </div>
  );
}
